import { PandaDocStatus } from "@/types";
import { ChipProps } from "@mui/material";
type ChipColor = ChipProps["color"];

export const getPandaDocStatusDisplay = (status: PandaDocStatus): { label: string; color: ChipColor } => {
  const statusMap: Record<PandaDocStatus, { label: string; color: ChipColor }> = {
    [PandaDocStatus.DRAFT]: { label: "Draft", color: "default" },
    [PandaDocStatus.SENT]: { label: "Sent", color: "info" },
    [PandaDocStatus.VIEWED]: { label: "Viewed", color: "info" },
    [PandaDocStatus.COMPLETED]: { label: "Completed", color: "success" },
    [PandaDocStatus.UPLOADED]: { label: "Uploaded", color: "default" },
    [PandaDocStatus.ERROR]: { label: "Error", color: "error" },
    [PandaDocStatus.WAITING_APPROVAL]: { label: "Awaiting Approval", color: "warning" },
    [PandaDocStatus.APPROVED]: { label: "Approved", color: "success" },
    [PandaDocStatus.REJECTED]: { label: "Rejected", color: "error" },
    [PandaDocStatus.WAITING_PAY]: { label: "Awaiting Payment", color: "warning" },
    [PandaDocStatus.PAID]: { label: "Paid", color: "success" },
    [PandaDocStatus.VOIDED]: { label: "Voided", color: "default" },
    [PandaDocStatus.DECLINED]: { label: "Declined", color: "error" },
    [PandaDocStatus.EXTERNAL_REVIEW]: { label: "External Review", color: "warning" },
  };
  return statusMap[status] ?? { label: status, color: "default" };
};
